import { render, staticRenderFns } from "./FormTip.vue?vue&type=template&id=fafc3ade&"
import script from "./FormTip.vue?vue&type=script&lang=js&"
export * from "./FormTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports